import apiHub from '@/services/hub';
import { MutationTree } from 'vuex';

const mutations: MutationTree<Store.User.State> = {
  setLanguage(state, payload: Store.User.Language) {
    state.settings.lang = payload;
  },
  setUser(state, payload: Services.User.RegisterResponse & { page: Store.User.Page }) {
    localStorage.setItem('user', JSON.stringify(payload));
    if (payload.user?.plan_id) {
      state.planId = payload.user?.plan_id;
    }
    state.token = payload.token;
    state.logged = true;
    state.page = payload.page;
    apiHub.changeAuth(`Bearer ${payload.token}`);
  },
};

export default mutations;
